import React, {useState, useMemo, useEffect} from "react";
import UserProfileContext from "./UserProfileContext";
import AuthAPI from "../../api/firebase/AuthAPI";

const UserProfileState = (props) => {
  const [state, setState] = useState(null);
  const [isFirstRender, setIsFirstRender] = useState(true);
  const authAPI = new AuthAPI();

  const value = useMemo(
    () => ({
      state,
      setState,
    }),
    [state]
  );
  useEffect(() => {
    const userProfile = JSON.parse(localStorage.getItem("user"));
    console.log("🔄 UserProfileState: Loading user from localStorage:", userProfile);
    
    if (userProfile) {
      const userId = userProfile.id || userProfile.uid;
      console.log("🆔 UserProfileState: Fetching user details for ID:", userId);
      
      // Fetch User Data using userID from firestore database
      authAPI.getUserDetailById(userId).then((res) => {
        console.log("📥 UserProfileState: Received user data from database:", res);
        console.log("📋 UserProfileState: User orders from database:", res?.orders?.length || 0, "orders");
        
        if (res?.orders) {
          res.orders.forEach((order, index) => {
            console.log(`📦 DB Order ${index + 1}: ID=${order.id}, Status=${order.status}`);
          });
        }
        
        setState({...res, id: userId});
      });
    }
  }, []);
  useEffect(() => {
    //console.log("UserProfileState state:", state);
    if (!isFirstRender) {
      localStorage.setItem("user", JSON.stringify(state));
      // console.log(
      //   "localstorage user:",
      //   JSON.parse(localStorage.getItem("user"))
      // );
    }
    return setIsFirstRender(false);
  }, [state]);

  return (
    <UserProfileContext.Provider value={value}>
      {props.children}
    </UserProfileContext.Provider>
  );
};

export default UserProfileState;
